import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { faShieldExclamation } from '@fortawesome/pro-light-svg-icons';
import { EVALUATION_STATUS } from '../../../../models/submission';
import { combine } from '../../../../helpers/styles';
import { ROLES } from '../../../../config/permissions/roles';
import { useJuror } from '../../../../hooks/useAuth';
import styles from './styles.module.scss';

const StatusIcon = ({ score, status, hasZeroValues }) => {
  const { role } = useJuror();

  if (status === EVALUATION_STATUS.toBeDecidedByChairperson) {
    return (
      <FontAwesomeIcon
        icon={faShieldExclamation}
        className={combine(styles.icon, styles.red)}
      />
    );
  }
  if (status === EVALUATION_STATUS.decidedByChairperson) {
    return (
      <FontAwesomeIcon
        icon={faShieldExclamation}
        className={combine(styles.icon, styles.green)}
      />
    );
  }
  if (isNaN(score) || status === EVALUATION_STATUS.toBeDecided) {
    return (
      <FontAwesomeIcon
        icon={faCircle}
        className={combine(styles.icon, styles.red)}
      />
    );
  }
  if (status === EVALUATION_STATUS.decided) {
    return (
      <FontAwesomeIcon
        icon={faCircleCheck}
        className={combine(
          styles.icon,
          styles.green,
          role === ROLES.staff && hasZeroValues && styles.red
        )}
      />
    );
  }

  return null;
};

export default StatusIcon;
